import React from "react";

export const DotIcon = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    className="svg"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Scouts-V1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <circle id="Oval" fill="#FFFFFF" cx="12" cy="12" r="12"></circle>
    </g>
  </svg>
);

export const GroupThreeIcon = () => (
  <svg
    width="117.85px"
    viewBox="0 0 221 120"
    className="svg"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Scouts-V1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Splash-V1"
        transform="translate(-61.000000, -261.000000)"
        fillRule="nonzero"
      >
        <g id="Group-2" transform="translate(60.000000, 261.000000)">
          <g id="Group" transform="translate(0.560748, 0.500000)">
            <g id="Group-3" transform="translate(0.439252, 0.000000)">
              <path
                d="M30,27.5351201 L39.8960379,27.5351201 L47.5282763,51.0194085 L55.4192347,27.5351201 L64.7978327,27.5351201 L52.0558754,60.4648799 L42.7419573,60.4648799 L30,27.5351201 Z M84.6545886,61.5 C80.8168902,61.5 77.4643444,60.8099268 74.5968507,59.4297597 C71.7293569,58.0495926 69.4979197,56.033285 67.9024721,53.3807763 C66.3070244,50.7282677 65.5093126,47.6121559 65.5093126,44.0323475 C65.5093126,40.7113204 66.1992255,37.7245974 67.5790721,35.0720887 C68.9589187,32.4195801 70.9208587,30.3277957 73.4649509,28.7966728 C76.0090431,27.26555 78.9627329,26.5 82.326109,26.5 C85.4307639,26.5 88.1580761,27.157726 90.5081273,28.4731978 C92.8581786,29.7886695 94.6907599,31.6755884 96.0059262,34.1340111 C97.3210925,36.5924337 97.9786658,39.50368 97.9786658,42.8678373 C97.9786658,44.2911347 97.8708669,45.5850219 97.6552658,46.7495379 L74.4351507,46.7495379 C75.5562761,51.6663832 79.286118,54.1247689 85.6247884,54.1247689 C87.6083179,54.1247689 89.5379182,53.9199035 91.4136471,53.5101664 C93.2893761,53.1004293 94.9818188,52.5073976 96.4910261,51.7310536 L97.3965459,58.7828096 C95.8442184,59.645414 93.9469578,60.3139225 91.7047071,60.7883549 C89.4624563,61.2627873 87.1124403,61.5 84.6545886,61.5 Z M89.3762276,40.474122 C89.1606265,38.1882202 88.4168141,36.4306901 87.144768,35.2014787 C85.8727219,33.9722674 84.1802792,33.357671 82.0673891,33.357671 C79.9976192,33.357671 78.2943966,33.9722674 76.9576702,35.2014787 C75.6209438,36.4306901 74.7585526,38.1882202 74.3704707,40.474122 L89.3762276,40.474122 Z M103.864545,27.5351201 L112.531663,27.5351201 L112.596343,32.9695009 C113.501867,31.0286409 114.719995,29.5406706 116.250762,28.5055453 C117.781529,27.47042 119.560211,26.9528651 121.586861,26.9528651 C122.966707,26.9528651 124.238734,27.1900777 125.40298,27.6645102 L124.62682,36.1395564 C123.290094,35.6219937 121.953387,35.3632163 120.616661,35.3632163 C118.158809,35.3632163 116.250769,36.2473726 114.892482,38.0157116 C113.534196,39.7840507 112.855063,42.2640013 112.855063,45.4556377 L112.855063,60.4648799 L103.864545,60.4648799 L103.864545,27.5351201 Z M139.891297,61.5 C137.390325,61.5 135.018749,61.2088754 132.776498,60.6266174 C130.534248,60.0443594 128.809465,59.2788094 127.6021,58.3299445 L128.701659,51.0194085 C130.167746,52.0114036 131.881749,52.8093007 133.843718,53.4131238 C135.805688,54.016947 137.692168,54.318854 139.503217,54.318854 C143.168435,54.318854 145.001016,53.3915681 145.001016,51.5369686 C145.001016,50.5449735 144.61294,49.7902059 143.836776,49.2726433 C143.189973,48.841341 141.959267,48.350142 140.144631,47.7990357 L138.985777,47.461183 C135.104959,46.3829274 132.334527,45.0135634 130.674399,43.3530499 C129.014271,41.6925364 128.184219,39.4605809 128.184219,36.6571165 C128.184219,33.5086103 129.370007,31.0286597 131.741619,29.2171904 C134.11323,27.4057211 137.368757,26.5 141.508297,26.5 C143.534946,26.5 145.561566,26.7372127 147.588215,27.2116451 C149.614865,27.6860775 151.274968,28.3114564 152.568574,29.0878004 L151.533695,36.2042514 C150.196968,35.4279074 148.655444,34.813311 146.909076,34.3604436 C145.162707,33.9075763 143.491824,33.681146 141.896377,33.681146 C138.748601,33.681146 137.174738,34.5221727 137.174738,36.2042514 C137.174738,37.1531163 137.552034,37.8971014 138.306637,38.4362292 C138.92404,38.8773337 140.03936,39.3545227 141.65262,39.8678058 L142.801896,40.215342 C146.941436,41.4229882 149.862786,42.8462641 151.566035,44.4852126 C153.269283,46.124161 154.120894,48.3884637 154.120894,51.2781885 C154.120894,54.469825 152.859647,56.9713403 150.337115,58.7828096 C147.814583,60.5942789 144.332678,61.5 139.891297,61.5 Z M174.36573,61.5 C169.450026,61.5 165.687845,60.2276775 163.079072,57.6829945 C160.4703,55.1383114 159.165933,51.5154271 159.165933,46.8142329 L159.165933,27.5351201 L168.156451,27.5351201 L168.156451,46.6201479 C168.156451,51.2350816 170.24775,53.5425139 174.43041,53.5425139 C178.483709,53.5425139 180.510328,51.2350816 180.510328,46.6201479 L180.510328,27.5351201 L189.500847,27.5351201 L189.500847,46.8142329 C189.500847,51.5585573 188.19648,55.192224 185.587707,57.715342 C182.978935,60.2384599 179.238313,61.5 174.36573,61.5 Z M206.770403,61.5 C204.269431,61.5 201.897855,61.2088754 199.655604,60.6266174 C197.413354,60.0443594 195.688571,59.2788094 194.481206,58.3299445 L195.580765,51.0194085 C197.046852,52.0114036 198.760855,52.8093007 200.722824,53.4131238 C202.684794,54.016947 204.571274,54.318854 206.382323,54.318854 C210.047541,54.318854 211.880122,53.3915681 211.880122,51.5369686 C211.880122,50.5449735 211.492046,49.7902059 210.715882,49.2726433 C210.069079,48.841341 208.838373,48.350142 207.023737,47.7990357 L205.864883,47.461183 C201.984065,46.3829274 199.213633,45.0135634 197.553505,43.3530499 C195.893377,41.6925364 195.063325,39.4605809 195.063325,36.6571165 C195.063325,33.5086103 196.249113,31.0286597 198.620725,29.2171904 C200.992336,27.4057211 204.247863,26.5 208.387403,26.5 C210.414052,26.5 212.440672,26.7372127 214.467321,27.2116451 C216.493971,27.6860775 218.154074,28.3114564 219.44768,29.0878004 L218.412801,36.2042514 C217.076074,35.4279074 215.53455,34.813311 213.788182,34.3604436 C212.041813,33.9075763 210.37093,33.681146 208.775483,33.681146 C205.627707,33.681146 204.053844,34.5221727 204.053844,36.2042514 C204.053844,37.1531163 204.43114,37.8971014 205.185743,38.4362292 C205.803146,38.8773337 206.918466,39.3545227 208.531726,39.8678058 L209.681002,40.215342 C213.820542,41.4229882 216.741892,42.8462641 218.445141,44.4852126 C220.148389,46.124161 221,48.3884637 221,51.2781885 C221,54.469825 219.738753,56.9713403 217.216221,58.7828096 C214.693689,60.5942789 211.211784,61.5 206.770403,61.5 Z"
                id="versus"
                fill="#FFFFFF"
              ></path>
              <path
                d="M48.8712871,118.5 C46.8436957,118.5 44.8269195,118.21768 42.8208982,117.65303 C40.8148768,117.088381 39.2079268,116.350005 38,115.437879 L38.8412306,110.551515 C40.1785781,111.55051 41.7639583,112.354037 43.5974187,112.962121 C45.430879,113.570205 47.1888176,113.874242 48.8712871,113.874242 C51.2871408,113.874242 53.1637133,113.450762 54.5010608,112.603788 C55.8384084,111.756814 56.5070721,110.594957 56.5070721,109.118182 C56.5070721,108.075752 56.2805893,107.250508 55.8276167,106.642424 C55.3746441,106.03434 54.5981314,105.4697 53.4980552,104.948485 C52.3979789,104.42727 50.791029,103.862629 48.677157,103.254545 C45.0533765,102.168681 42.4650007,100.865664 40.9119519,99.3454545 C39.3589031,97.8252449 38.5823904,95.8490021 38.5823904,93.4166667 C38.5823904,90.4631165 39.6716652,88.1285439 41.8502475,86.4128788 C44.0288298,84.6972136 46.9946771,83.8393939 50.7478784,83.8393939 C52.4734881,83.8393939 54.2422116,84.0782804 56.0541018,84.5560606 C57.8659921,85.0338408 59.3543082,85.6636325 60.5190948,86.4454545 L59.6131542,91.1363636 C56.8521786,89.3555467 53.8539766,88.4651515 50.6184583,88.4651515 C48.4614461,88.4651515 46.8005716,88.8451982 45.635785,89.605303 C44.4709984,90.3654078 43.8886139,91.4403971 43.8886139,92.830303 C43.8886139,94.1767744 44.3847192,95.2409052 45.3769448,96.0227273 C46.286485,96.7393975 47.9028729,97.4560579 50.2261509,98.1727265 L50.8772984,98.3681818 C54.9756216,99.5843495 57.8659746,100.963376 59.5484441,102.505303 C61.2309136,104.04723 62.0721358,106.142916 62.0721358,108.792424 C62.0721358,111.70254 60.8642271,114.047971 58.4483734,115.828788 C56.0325197,117.609605 52.8401896,118.5 48.8712871,118.5 Z M83.8794201,118.304545 C80.4282006,118.304545 77.3760741,117.63132 74.7229491,116.284848 C72.0698241,114.938377 69.9991234,112.983851 68.510785,110.421212 C67.0224466,107.858573 66.2782885,104.839916 66.2782885,101.365152 C66.2782885,98.0206903 66.9900919,95.0454676 68.4137199,92.4393939 C69.837348,89.8333203 71.8756939,87.7810681 74.528819,86.2825758 C77.181944,84.7840834 80.27721,84.0348485 83.81471,84.0348485 C85.4971796,84.0348485 87.1796238,84.252018 88.8620934,84.6863636 C90.5445629,85.1207092 92.0544488,85.707067 93.3917963,86.4454545 L92.6152758,91.2015152 C91.3642087,90.5499967 89.9298171,90.0179314 88.312058,89.605303 C86.6942988,89.1926747 85.1951979,88.9863636 83.81471,88.9863636 C80.2340698,88.9863636 77.3545017,90.0830698 75.1759194,92.2765152 C72.9973371,94.4699605 71.9080622,97.4126078 71.9080622,101.104545 C71.9080622,104.926787 72.9973371,107.923727 75.1759194,110.095455 C77.3545017,112.267183 80.3634886,113.35303 84.2029703,113.35303 C87.0502264,113.35303 90.1131378,112.636371 93.3917963,111.20303 L94.0388967,115.828788 C92.6584089,116.610606 91.0730288,117.218685 89.2827086,117.65303 C87.4923885,118.087376 85.6913103,118.304545 83.8794201,118.304545 Z M115.846181,118.5 C112.740083,118.5 109.903655,117.772482 107.33681,116.317424 C104.769966,114.862366 102.720835,112.810114 101.189356,110.160606 C99.6578778,107.511098 98.8921499,104.514158 98.8921499,101.169697 C98.8921499,98.0858432 99.6147382,95.2300636 101.059936,92.6022727 C102.505135,89.9744818 104.521911,87.8570787 107.110325,86.25 C109.69874,84.6429213 112.610663,83.8393939 115.846181,83.8393939 C118.952279,83.8393939 121.788707,84.5669119 124.355552,86.0219697 C126.922396,87.4770275 128.971527,89.5292797 130.503006,92.1787879 C132.034484,94.8282961 132.800212,97.8252358 132.800212,101.169697 C132.800212,104.253551 132.077624,107.10933 130.632426,109.737121 C129.187228,112.364912 127.170451,114.482315 124.582037,116.089394 C121.993622,117.696473 119.081699,118.5 115.846181,118.5 Z M115.846181,113.548485 C119.16798,113.548485 121.885774,112.397486 123.999646,110.095455 C126.113518,107.793423 127.170438,104.8182 127.170438,101.169697 C127.170438,97.5211939 126.113518,94.5459711 123.999646,92.2439394 C121.885774,89.9419077 119.16798,88.7909091 115.846181,88.7909091 C112.524382,88.7909091 109.806588,89.9419077 107.692716,92.2439394 C105.578844,94.5459711 104.521924,97.5211939 104.521924,101.169697 C104.521924,104.8182 105.578844,107.793423 107.692716,110.095455 C109.806588,112.397486 112.524382,113.548485 115.846181,113.548485 Z M153.636846,118.5 C149.279681,118.5 145.871653,117.305568 143.412659,114.916667 C140.953665,112.527766 139.724187,109.226789 139.724187,105.013636 L139.724187,84.8818182 L145.22454,84.8818182 L145.22454,105.013636 C145.22454,107.836883 145.936344,109.976003 147.359972,111.431061 C148.7836,112.886118 150.89744,113.613636 153.701556,113.613636 C156.462531,113.613636 158.544017,112.886118 159.946075,111.431061 C161.348133,109.976003 162.049151,107.836883 162.049151,105.013636 L162.049151,84.8818182 L167.549505,84.8818182 L167.549505,105.013636 C167.549505,109.226789 166.320026,112.527766 163.861033,114.916667 C161.402039,117.305568 157.99401,118.5 153.636846,118.5 Z M179.909123,89.6378788 L172.467468,89.6378788 L172.467468,84.8818182 L179.909123,84.8818182 L179.909123,75.5 L185.409477,75.5 L185.409477,84.8818182 L194.468883,84.8818182 L194.468883,89.6378788 L185.409477,89.6378788 L185.409477,117.457576 L179.909123,117.457576 L179.909123,89.6378788 Z M207.799151,118.5 C205.77156,118.5 203.754784,118.21768 201.748762,117.65303 C199.742741,117.088381 198.135791,116.350005 196.927864,115.437879 L197.769095,110.551515 C199.106442,111.55051 200.691823,112.354037 202.525283,112.962121 C204.358743,113.570205 206.116682,113.874242 207.799151,113.874242 C210.215005,113.874242 212.091577,113.450762 213.428925,112.603788 C214.766273,111.756814 215.434936,110.594957 215.434936,109.118182 C215.434936,108.075752 215.208453,107.250508 214.755481,106.642424 C214.302508,106.03434 213.525996,105.4697 212.425919,104.948485 C211.325843,104.42727 209.718893,103.862629 207.605021,103.254545 C203.981241,102.168681 201.392865,100.865664 199.839816,99.3454545 C198.286767,97.8252449 197.510255,95.8490021 197.510255,93.4166667 C197.510255,90.4631165 198.599529,88.1285439 200.778112,86.4128788 C202.956694,84.6972136 205.922541,83.8393939 209.675743,83.8393939 C211.401352,83.8393939 213.170076,84.0782804 214.981966,84.5560606 C216.793856,85.0338408 218.282172,85.6636325 219.446959,86.4454545 L218.541018,91.1363636 C215.780043,89.3555467 212.781841,88.4651515 209.546322,88.4651515 C207.38931,88.4651515 205.728436,88.8451982 204.563649,89.605303 C203.398863,90.3654078 202.816478,91.4403971 202.816478,92.830303 C202.816478,94.1767744 203.312583,95.2409052 204.304809,96.0227273 C205.214349,96.7393975 206.830737,97.4560579 209.154015,98.1727265 L209.805163,98.3681818 C213.903486,99.5843495 216.793839,100.963376 218.476308,102.505303 C220.158778,104.04723 221,106.142916 221,108.792424 C221,111.70254 219.792091,114.047971 217.376238,115.828788 C214.960384,117.609605 211.768054,118.5 207.799151,118.5 Z"
                id="scouts"
                fill="#FFFFFF"
              ></path>
              <path
                d="M19,0.5 C19,7.52362127 24.5699924,13.2463011 31.5337317,13.491794 L32,13.5 L32,19.5 C24.9763787,19.5 19.2536989,25.0699924 19.008206,32.0337317 L19,32.5 L13,32.5 C13,25.3202983 7.17970175,19.5 0,19.5 L0,13.5 C7.02362127,13.5 12.7463011,7.93000758 12.991794,0.966268268 L13,0.5 L19,0.5 Z M15.9975543,10.5 L15.9617988,10.5616574 C14.4219765,12.9415857 12.3858916,14.9704889 10,16.5019154 C12.4059471,18.0440102 14.4561586,20.0941589 16.0004902,22.5 C17.5440391,20.093869 19.5940141,18.0435162 22,16.4991661 C19.5932455,14.9563212 17.5422857,12.9063655 15.9975543,10.5 Z"
                id="Shape"
                fill="#E12FFF"
                transform="translate(16.000000, 16.500000) scale(-1, 1) translate(-16.000000, -16.500000) "
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const VersusArrow = () => (
  <svg
    width="385px"
    viewBox="0 0 184 64"
    version="1.1"
    className="svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Scouts-V1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-12" transform="translate(4.000000, 0.000000)">
        <circle id="Oval" fill="#FC4C76" cx="148" cy="32" r="32"></circle>
        <circle
          id="Oval"
          stroke="#F9F9F9"
          strokeWidth="8"
          cx="10"
          cy="32"
          r="10"
        ></circle>
        <rect
          id="Rectangle"
          fill="#F9F9F9"
          x="18"
          y="28"
          width="144"
          height="8"
        ></rect>
        <path
          d="M162,36 C161.508629,36 161.020569,35.985824 160.536207,35.9578586 C151.774453,36.6990433 144.894737,44.0460998 144.894737,53 L144.894737,53 L137,53 C137,44.1951746 141.551738,36.4534647 148.430513,31.9995714 C141.551738,27.5465353 137,19.8048254 137,11 L144.894737,11 C144.894737,19.9539002 151.774453,27.3009567 160.536226,28.0435092 C161.020569,28.014176 161.508629,28 162,28 L162,28 L162,36 Z"
          id="Combined-Shape-Copy-46"
          fill="#F9F9F9"
          fillRule="nonzero"
        ></path>
      </g>
    </g>
  </svg>
);

export const GroupFifteenIcon = () => (
  <svg
    width="385px"
    viewBox="0 0 186 56"
    version="1.1"
    className="svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Scouts-V1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-15" transform="translate(0.000000, -10.600000)">
        <g
          id="Group-14"
          transform="translate(154.000000, 15.600000)"
          fill="#F9F9F9"
        >
          <rect id="Rectangle" x="2" y="38" width="28" height="8"></rect>
          <path
            d="M16,0 C7.163444,0 0,7.163444 0,16 C0,24.836556 7.163444,32 16,32 C24.836556,32 32,24.836556 32,16 C32,7.163444 24.836556,0 16,0 Z M16,9 C19.8659932,9 23,12.1340068 23,16 C23,19.8659932 19.8659932,23 16,23 C12.1340068,23 9,19.8659932 9,16 C9,12.1340068 12.1340068,9 16,9 Z"
            id="Oval"
            fillRule="nonzero"
          ></path>
        </g>
        <circle
          id="Oval-Copy-7"
          fill="#4DABF7"
          cx="27"
          cy="38.6"
          r="27"
        ></circle>
        <circle
          id="Oval-Copy-8"
          fill="#FC4C76"
          cx="115"
          cy="38.6"
          r="27"
        ></circle>
        <rect
          id="Rectangle"
          fill="#F9F9F9"
          transform="translate(115.000000, 38.600000) rotate(-315.000000) translate(-115.000000, -38.600000) "
          x="101"
          y="34.6"
          width="28"
          height="8"
        ></rect>
        <rect
          id="Rectangle"
          fill="#F9F9F9"
          transform="translate(115.000000, 38.600000) rotate(-45.000000) translate(-115.000000, -38.600000) "
          x="101"
          y="34.6"
          width="28"
          height="8"
        ></rect>
        <g
          id="Group-13"
          transform="translate(36.000000, 27.000000) rotate(-315.000000) translate(-36.000000, -27.000000) translate(22.000000, 4.000000)"
          fill="#F9F9F9"
        >
          <rect
            id="Rectangle-Copy-9"
            x="0"
            y="37.6"
            width="28"
            height="8"
          ></rect>
          <rect
            id="Rectangle-Copy-9"
            transform="translate(24.000000, 23.000000) rotate(-270.000000) translate(-24.000000, -23.000000) "
            x="1.6"
            y="19"
            width="44.8"
            height="8"
          ></rect>
        </g>
        <circle id="Oval" fill="#F9F9F9" cx="71" cy="40.6" r="6"></circle>
      </g>
    </g>
  </svg>
);

export const GroupSixteenIcon = () => (
  <svg
    width="739"
    className="svg"
    viewBox="0 0 382 64"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Scouts-V1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-16" transform="translate(-194.000000, 0.000000)">
        <path
          d="M226,0 L458,0 C475.673112,0 490,14.326888 490,32 C490,49.673112 475.673112,64 458,64 L226,64 C208.326888,64 194,49.673112 194,32 C194,14.326888 208.326888,0 226,0 Z"
          id="Rectangle"
          fill="#4517A6"
        ></path>
        <rect
          id="Rectangle"
          fill="#F9F9F9"
          x="238"
          y="28"
          width="50"
          height="8"
        ></rect>
        <line
          x1="287.5"
          y1="32"
          x2="447.5"
          y2="32"
          id="Line-4"
          stroke="#F9F9F9"
          strokeWidth="8"
          strokeLinecap="square"
          strokeDasharray="8,17"
        ></line>
        <circle
          id="Oval-Copy-9"
          fill="#4DABF7"
          cx="226"
          cy="32"
          r="19"
        ></circle>
        <polygon
          id="Polygon"
          stroke="#F9F9F9"
          strokeWidth="8"
          transform="translate(224.500000, 31.500000) rotate(-270.000000) translate(-224.500000, -31.500000) "
          points="224.5 27.5 227.964102 33.5 221.035898 33.5"
        ></polygon>
        <circle
          id="Oval-Copy-9"
          stroke="#F9F9F9"
          strokeWidth="8"
          fill="#F9F9F9"
          cx="300"
          cy="32"
          r="10"
        ></circle>
        <circle
          id="Oval-Copy-10"
          stroke="#F9F9F9"
          strokeWidth="8"
          cx="458"
          cy="32"
          r="10"
        ></circle>
      </g>
      <g id="Group-17" transform="translate(313.000000, 0.000000)">
        <rect
          id="Rectangle"
          stroke="#F9F9F9"
          strokeWidth="8"
          x="4"
          y="13"
          width="52"
          height="41"
        ></rect>
        <circle id="Oval" fill="#E12FFF" cx="56" cy="13" r="13"></circle>
        <circle
          id="Oval-Copy-11"
          stroke="#F9F9F9"
          strokeWidth="8"
          cx="30"
          cy="34"
          r="8"
        ></circle>
      </g>
    </g>
  </svg>
);

export const GroupNineteenIcon = () => (
  <svg
    width="202px"
    viewBox="0 0 75 42"
    className="svg"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Scouts-V1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-12"
        transform="translate(0.000000, -11.000000)"
        fillRule="nonzero"
      >
        <g id="Group-19" transform="translate(0.000000, 11.000000)">
          <path
            d="M25,25 C24.508629,25 24.020569,24.985824 23.5362067,24.9578586 C14.7744531,25.6990433 7.89473684,33.0460998 7.89473684,42 L7.89473684,42 L0,42 C0,33.1951746 4.55173813,25.4534647 11.4305132,20.9995714 C4.55173813,16.5465353 0,8.80482535 0,0 L7.89473684,0 C7.89473684,8.95390025 14.7744531,16.3009567 23.5362257,17.0435092 C24.020569,17.014176 24.508629,17 25,17 L25,17 L25,25 Z"
            id="Combined-Shape-Copy-46"
            fill="#4DABF7"
            transform="translate(12.500000, 21.000000) rotate(-180.000000) translate(-12.500000, -21.000000) "
          ></path>
          <path
            d="M50,25 C49.508629,25 49.020569,24.985824 48.5362067,24.9578586 C39.7744531,25.6990433 32.8947368,33.0460998 32.8947368,42 L32.8947368,42 L25,42 C25,33.1951746 29.5517381,25.4534647 36.4305132,20.9995714 C29.5517381,16.5465353 25,8.80482535 25,0 L32.8947368,0 C32.8947368,8.95390025 39.7744531,16.3009567 48.5362257,17.0435092 C49.020569,17.014176 49.508629,17 50,17 L50,17 L50,25 Z"
            id="Combined-Shape-Copy-49"
            fill="#4517A6"
            transform="translate(37.500000, 21.000000) rotate(-180.000000) translate(-37.500000, -21.000000) "
          ></path>
          <path
            d="M75,25 C74.508629,25 74.020569,24.985824 73.5362067,24.9578586 C64.7744531,25.6990433 57.8947368,33.0460998 57.8947368,42 L57.8947368,42 L50,42 C50,33.1951746 54.5517381,25.4534647 61.4305132,20.9995714 C54.5517381,16.5465353 50,8.80482535 50,0 L57.8947368,0 C57.8947368,8.95390025 64.7744531,16.3009567 73.5362257,17.0435092 C74.020569,17.014176 74.508629,17 75,17 L75,17 L75,25 Z"
            id="Combined-Shape-Copy-50"
            fill="#E12FFF"
            transform="translate(62.500000, 21.000000) rotate(-180.000000) translate(-62.500000, -21.000000) "
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const GroupTwentyOneIcon = () => (
  <svg
    width="274px"
    viewBox="0 0 121 46"
    version="1.1"
    className="svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Scouts-V1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-21" transform="translate(4.000000, 0.000000)">
        <g id="Group-18">
          <path
            d="M40,46 C40,34.954305 31.045695,26 20,26 C8.954305,26 0,34.954305 0,46"
            id="Oval-Copy-13"
            stroke="#F9F9F9"
            strokeWidth="8"
          ></path>
          <circle
            id="Oval-Copy-12"
            fill="#E12FFF"
            cx="20"
            cy="15"
            r="15"
          ></circle>
        </g>
        <path
          d="M78,27 C77.508629,27 77.020569,26.985824 76.5362067,26.9578586 C67.7744531,27.6990433 60.8947368,35.0460998 60.8947368,44 L60.8947368,44 L53,44 C53,35.1951746 57.5517381,27.4534647 64.4305132,22.9995714 C57.5517381,18.5465353 53,10.8048254 53,2 L60.8947368,2 C60.8947368,10.9539002 67.7744531,18.3009567 76.5362257,19.0435092 C77.020569,19.014176 77.508629,19 78,19 L78,19 L78,27 Z"
          id="Combined-Shape-Copy-46"
          fill="#F9F9F9"
          fillRule="nonzero"
          transform="translate(65.500000, 23.000000) rotate(-180.000000) translate(-65.500000, -23.000000) "
        ></path>
        <rect
          id="Rectangle"
          fill="#F9F9F9"
          x="53"
          y="19"
          width="64"
          height="8"
        ></rect>
      </g>
    </g>
  </svg>
);

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-search absolute-top-left icon margin-4"
    src="https://assets.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg"
    loading="lazy"
    alt=""
  >
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);
